import React from 'react';
import {TableCell} from 'material-ui';
import MenusTableItemActionEdit from './MenusTableItemActionEdit';
import MenusTableItemActionAddTranslation from './MenusTableItemActionAddTranslation';

class MenusTableItemActions extends React.Component {

    render() {

        const {
            menu,
            classes,
            sites,
            handleClickOpen
        } = this.props;

        const menuSiteId = menu.site.id;
        const isMasterWebsite = menuSiteId === 0;

        return (
            <TableCell className={classes.tableCell}>
                <span id="buttons">
                    <MenusTableItemActionEdit
                        classes={classes}
                        menu={menu}
                        menuSiteId={menuSiteId}
                    />
                    {isMasterWebsite ?
                        <MenusTableItemActionAddTranslation
                            classes={classes}
                            menu={menu}
                            sites={sites}
                            handleClickOpen={handleClickOpen}
                        />
                    : ''}
                </span>
            </TableCell>
        )
    }
};

export default MenusTableItemActions;


// WEBPACK FOOTER //
// ./src/containers/menus/MenusTableItemActions.jsx